import { useState } from 'react';
import { MIN, fmt, goldQty, offersLive } from '../campaign';

/* static fallback until resp.independence.gold arrives */
const CHIPS = [
  { amount: 2500, label: '₹2,500', scLabel: null },
  { amount: 5000, label: '₹5,000', scLabel: '₹250 in SuperCoin' },
  { amount: 10000, label: '₹10,000', scLabel: null },
];

export default function InvestSection({ S, gold, min = MIN, amount, display, onAmountInput, onChip, onBuyNow, onDelivery, fieldRef, inputRef, first }) {
  const [focus, setFocus] = useState(false);
  const live = offersLive(S);
  const ok = amount >= min;
  const chips = gold && gold.quickAmounts && gold.quickAmounts.length ? gold.quickAmounts : CHIPS;
  const mgPerRupee = (gold && gold.price && gold.price.buyPerGram)
    ? 1000 / gold.price.buyPerGram
    : (gold && gold.mgPerRupee);
  const ctaEnabled = live && ok && !(gold && gold.cta && gold.cta.enabled === false);
  const showDelivery = gold ? gold.freeDelivery !== false : true;

  let iSub;
  if (!live) {
    iSub = 'The 5% SuperCoins offer has closed.<br>24K gold buying stays open year-round.';
  } else if (gold && gold.subTitle && !gold.freeDelivery) {
    iSub = gold.subTitle;
  } else if (S.phase === 'final48') {
    iSub = 'Earn <b>5% back</b> in SuperCoins. <b>Ends Aug 22nd.</b>';
  } else {
    iSub = 'Earn <b>5% back</b> in SuperCoins.';
  }

  let dcEyebrow, dcTitle, dcLabel;
  if (!live) { dcEyebrow = 'Aug 11th – Aug 22nd'; dcTitle = 'Delivery offer closed'; dcLabel = ''; }
  else if (S.phase === 'final48') { dcEyebrow = 'only ' + S.daysToEnd + ' days left'; dcTitle = 'Free Gold Delivery'; dcLabel = 'Buy Gold Now'; }
  else { dcEyebrow = 'from Aug 11th – Aug 22nd'; dcTitle = 'Free Gold Delivery'; dcLabel = 'Buy Gold Now'; }

  return (
    <section className={'gfg-invest' + (first ? ' gfg-invest-first' : '')}>
      <h2 className="gfg-sec-title gfg-rv">{(gold && gold.title) || 'Buy Gold'}</h2>
      <h2 className="gfg-sec-title gfg-it gfg-rv" style={{ marginTop: -6 }}>{(gold && gold.highlight) || 'Earn Supercoins'}</h2>
      {live && gold && gold.freeDelivery && (
        <p className="gfg-sec-sub" style={{ fontSize: 15, marginTop: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, opacity: 1, transform: 'none' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5C3A1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 3h15v13H1z" /><path d="M16 8h4l3 3v5h-7V8z" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
          </svg>
          <span>Delivery for Just ₹1</span>
        </p>
      )}

      <div
        ref={fieldRef}
        className={'gfg-field' + (focus ? ' gfg-focus' : '') + (!ok && amount > 0 ? ' gfg-err' : '')}
        style={{ opacity: 1, transform: 'none' }}
      >
        <label htmlFor="gfg-amount">Enter Amount</label>
        <div className="gfg-amt-row">
          <span className="gfg-rup">₹</span>
          <input
            id="gfg-amount"
            className="gfg-amount"
            ref={inputRef}
            inputMode="numeric"
            autoComplete="off"
            value={display}
            aria-label="Amount in rupees"
            onChange={(e) => onAmountInput(e.target.value)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          />
        </div>
      </div>
      <div className={'gfg-result gfg-rv' + (!ok ? ' gfg-warn' : '')}>
        {ok ? "You'll get " + goldQty(amount, mgPerRupee) + ' worth of gold' : 'Please add Minimum ₹' + fmt(min)}
      </div>

      <div className="gfg-chips gfg-rv">
        {chips.map((c) => (
          <button key={c.amount} className={'gfg-chip' + (amount === c.amount ? ' gfg-on' : '')} onClick={() => onChip(c.amount)}>
            {c.scLabel && <span className="gfg-tag">{c.scLabel}</span>}
            {c.label || '₹' + fmt(c.amount)}
          </button>
        ))}
      </div>

      <div className="gfg-cta-wrap gfg-rv" style={{ marginTop: 32 }}>
        <button className={'gfg-cta' + (!ctaEnabled ? ' gfg-dead' : '')} onClick={onBuyNow}>
          <span>{live ? (gold && gold.cta && gold.cta.text) || 'Buy Now' : 'Offer closed'}</span>
          <svg viewBox="0 0 24 24"><path d="M4 12h15M13 6l6 6-6 6" /></svg>
        </button>
      </div>

    </section>
  );
}
